// Copyright 2025. WebPros International GmbH. All rights reserved.

import { DisasterRecoveryStatus } from 'common/api/resources/DisasterRecovery';
import React from 'react';
import {
    Action,
    Translate,
} from '@plesk/ui-library';
import { Status } from 'common/components/styles/Status';
import { INTENT_TYPE } from 'common/constants';

export interface IDisasterRecoveryStatusProps {
    status: string;
    totalProcesses?: number;
    completedProcesses?: number;
    compact?: boolean;
}

export const statusMappings: Record<DisasterRecoveryStatus, string> = {
    [DisasterRecoveryStatus.PENDING]: 'disasterRecovery.history.status.pending',
    [DisasterRecoveryStatus.RUNNING]: 'disasterRecovery.history.status.running',
    [DisasterRecoveryStatus.RUNNING_WITH_ERRORS]: 'disasterRecovery.history.status.runningWithErrors',
    [DisasterRecoveryStatus.COMPLETED]: 'disasterRecovery.history.status.completed',
    [DisasterRecoveryStatus.FAILED]: 'disasterRecovery.history.status.failed',
};

const intentMappings: Partial<Record<DisasterRecoveryStatus, INTENT_TYPE>> = {
    [DisasterRecoveryStatus.PENDING]: INTENT_TYPE.WARNING,
    [DisasterRecoveryStatus.RUNNING]: INTENT_TYPE.PRIMARY,
    [DisasterRecoveryStatus.RUNNING_WITH_ERRORS]: INTENT_TYPE.DANGER,
    [DisasterRecoveryStatus.COMPLETED]: INTENT_TYPE.SUCCESS,
    [DisasterRecoveryStatus.FAILED]: INTENT_TYPE.DANGER,
};

export const DisasterRecoveryProcessStatus: React.FC<IDisasterRecoveryStatusProps> = ({
    status,
    totalProcesses,
    completedProcesses,
    compact,
}) => {
    if (status === DisasterRecoveryStatus.RUNNING) {
        const processingProgress = (completedProcesses !== undefined && totalProcesses !== undefined)
            ? `${completedProcesses}/${totalProcesses}`
            : '';
        return (
            <Action progress={true}>
                <Translate content={statusMappings[status]} /> {processingProgress}
            </Action>
        );
    }

    return (
        <Status
            intent={intentMappings[status]}
            compact={compact}
        >
            <Translate content={statusMappings[status]} />
        </Status>
    );
};
